import { z } from 'zod/v3';

import { marketProductItemSchema } from './market-products';

/** 입점사 전시 아이템 타입 */
export const vendorDisplayItemTypeSchema = z.enum([
  'SHOWCASE',
  'SHOWCASE_GROUP',
]);
export type VendorDisplayItemType = z.infer<typeof vendorDisplayItemTypeSchema>;

/** 입점사 전시 아이템 (VendorDisplayForBuyerDto) */
export const vendorDisplayItemSchema = z.object({
  /** VendorDisplay ID */
  id: z.number(),
  /** 아이템 ID (쇼케이스/그룹 ID) */
  itemId: z.number(),
  /** 아이템 타입 */
  itemType: vendorDisplayItemTypeSchema,
  /** 아이템 코드 */
  code: z.string().optional(),
  /** 아이템명 */
  name: z.string().optional(),
  /** 아이템 설명 */
  description: z.string().optional(),
  /** 노출 순서 */
  displayOrder: z.number(),
  /** 핫딜 여부 (showcase만 해당) */
  isHotDeal: z.boolean().optional(),
  /** 메인 이미지 URL */
  mainImageUrl: z.string().optional(),
  /** 썸네일 이미지 URL */
  thumbnailUrl: z.string().optional(),
  /** 상품 목록 */
  products: z.array(marketProductItemSchema),
  /** 대표 상품 */
  representativeProduct: marketProductItemSchema.optional(),
});
export type VendorDisplayItem = z.infer<typeof vendorDisplayItemSchema>;

/** 입점사 전시 응답 (VendorDisplayForBuyerResponseDto) */
export const vendorDisplaySchema = z.object({
  /** 쇼케이스 아이템 목록 */
  showcaseItems: z.array(vendorDisplayItemSchema),
  /** Vendor ID */
  vendorId: z.number(),
  /** Vendor 이름 */
  vendorName: z.string().optional(),
});
export type VendorDisplay = z.infer<typeof vendorDisplaySchema>;
